"use strict";
// @ts-ignore
try {
    self['workbox:recipes:6.5.2'] && _();
}
catch (e) { }
